module.exports = __webpack_public_path__ + "img/ep-logo-drop-shadow.1b29cd71.png";